import Vue from 'vue';
import { ui } from '@/constants';
import { Component, Prop } from 'vue-property-decorator';
import { Menu, MonoMenuEntreeGroup, MonoMenuTileItem } from '@/models';
import { isDefined, isMenuItemRewardsExclusive } from '@/helpers';

@Component({
  name: 'CmgNutritionCalculatorMealBuilderGroup',
})
export default class CmgNutritionCalculatorMealBuilderGroup extends Vue {
  private expanded: boolean = true;
  private validationErrorMargin: string = '';
  private mobileExpandedGroups: string[] = ['INCLUDED INGREDIENT', 'PROTEIN OR VEGGIE', 'Rice', 'Beans', 'Top Things Off', 'Tortilla', 'Options', 'included sides', 'Included Toppings']; 

  @Prop({ required: true, type: Object })
  group?: MonoMenuEntreeGroup;

  get isExpanded(): boolean {
    return this.expanded;
  }

  get getCollapseUrl(): string {
    return this.$appStore.state.cms.images.icons.removeLarge.default;
  }

  get getExpandUrl(): string {
    return this.$appStore.state.cms.images.icons.addLarge.default;
  }

  get groupType(): string {
    return this.group?.type ?? '';
  }

  get items(): MonoMenuTileItem[] {
    const isEnrolledInLoyalty = this.$services.loyalty.isEnrolledInLoyalty(this.$appStore.state.customer.profile);
    let items: MonoMenuTileItem[] = [];

    if (this.groupType === 'pce') {
      items = this.$services.mealBuilderV2.getPreconfiguredMealTiles(this.$appStore.state.mealBuilderV2.topLevelMenuItem?.menuItemType || 'Lifestyle');
    } else if (this.groupType === 'entree') {
      items = this.group!.items.map(id => (this.$services.monoMenu.getMonoMenuEntree(id, true)) as MonoMenuTileItem).filter(this.$services.monoMenu.isItemAvailable);
    } else if (this.groupType) {
      items = this.group!.items.map(id => (this.$services.monoMenu.getMonoMenuItem(id, true)) as MonoMenuTileItem).filter(this.$services.monoMenu.isItemAvailable);
    }

    if (!isEnrolledInLoyalty) {
      items = items.filter(i => !isMenuItemRewardsExclusive(i.tags));
    }

    if (!this.$appStore.state.restaurant.selectedRestaurant) {
      const universalMenuFull = this.$appStore.state.menu.universalMenuFull?.menu;

      if (this.group?.title === 'PROTEIN OR VEGGIE') {
        items = items.filter(item => (universalMenuFull?.entrees?.find(entree => entree.itemId === item.itemId)?.isUniversal != false));
      } else if (this.group?.title === 'Drinks') {
        items = items.filter(item => (universalMenuFull?.drinks?.find(drink => drink.itemId === item.itemId)?.isUniversal != false));
      } else {
        items = items.filter(item => (universalMenuFull?.sides?.find(side => side.itemId === item.itemId)?.isUniversal != false) && !item.tags.find(tag => tag.value === 'nchide'));
      }

      // filter non-universal unique menu items
      if (this.$appStore.state.mealBuilderV2.entreeId) {
        const entreeType = this.$services.monoMenu.getMonoMenuEntree(this.$appStore.state.mealBuilderV2!.entreeId)?.itemType;
        if (entreeType) {
          const entreeContents = universalMenuFull?.entrees?.find(entree => Object.values(entree).includes(entreeType))?.contents;
          items = items.filter(item => (entreeContents?.find(entree => entree.itemId === item.itemId)?.isUniversal != false));
        }
      }
    } 

    return items;
  }

  get nutritionSections(): any[] {
    return this.$services.monoMenu.getTopLevelMenuNutritionDetailSections();
  }

  get isDesktop(): boolean {
    return this.$appStore.state.ui.clientWidth >= ui.breakpoints.desktop;
  }

  get showValidationError(): boolean {
    return !!this.group?.contentGroupName && !!this.$appStore.state.mealBuilderV2.sectionErrors[this.group.contentGroupName];
  }

  get validationErrorMessage(): string {
    this.validationErrorMargin = 15 + (this.$refs.title as HTMLElement).clientWidth + 'px';
    return !!this.group?.contentGroupName ? this.$appStore.state.mealBuilderV2.sectionErrors[this.group.contentGroupName] : '';
  }

  get isRendered(): boolean {
    return !!(this.$refs.title as HTMLElement);
  }

  mounted() {
    this.expanded = this.isMobileExpandedGroup(this.group);
  }

  toggleAccordion() {
    this.expanded = !this.expanded;
    this.$emit('group-toggled');
  }

  isMobileExpandedGroup(group: MonoMenuEntreeGroup | undefined): boolean {
    const topLevelMenuItem = this.$appStore.state.mealBuilderV2.topLevelMenuItem;

    if (topLevelMenuItem?.type == 'preconfigured') {
      return true;
    } else if ( topLevelMenuItem?.type == 'non-entree') {
      return true;
    }

    return this.mobileExpandedGroups.indexOf(group?.title || '') > -1;
  }
}
